export default [
  {
    position: "absolute",
    top: 12.8,
    left: 14,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "performanceFeedbackP2.ttTextOne",
    hover: false,
    id: "SP_Performance_Navigation_Performance",
    index: 0,
  },
  {
    position: "absolute",
    top: 26.1,
    left: 1,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 16,
    tooltipText: "performanceFeedbackP2.ttTextTwo",
    tooltipClass: "right",
    hover: false,
    id: "SP_Performance_Navigation_Performance_Objectives",
    index: 1,
  },
  {
    position: "absolute",
    top: 37.5,
    left: 31,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "performanceFeedbackP2.mTitleOne",
    mBody: "performanceFeedbackP2.mBodyOne",
    isVideo: true,
    videoThumb: "SP-Feedback-Thumb",
    videoURL: "SP-Feedback.mp4",
    vidIcon: true,
    id: "SP_Performance_Video_Feedback",
    index: 2,
  },
  {
    position: "absolute",
    top: 69,
    left: 56,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "performanceFeedbackP2.mTitleTwo",
    mBody: "performanceFeedbackP2.mBodyTwo",
    id: "SP_Performance_Info_Feedback",
    infoIcon: true,
    isAction: false,
    index: 3,
  },
];
